import React from "react";
import { Check, Circle } from "lucide-react";

const STAGES = ["pending_payment", "confirmed", "processing", "shipped", "delivered"];
const LABELS = {
  pending_payment: "Order placed",
  payment_failed: "Payment failed",
  confirmed: "Payment confirmed",
  processing: "Packing your order",
  shipped: "Shipped",
  delivered: "Delivered",
  cancelled: "Cancelled",
};

const when = (at) => (at ? new Date(at).toLocaleString() : "");

/**
 * The real journey of an order. `status_history` is appended to on every change,
 * so the buyer sees exactly what happened and when; the stages that have not
 * happened yet stay greyed out.
 */
export const OrderTimeline = ({ status, history = [] }) => {
  const done = history.filter((h) => h?.status);
  const reached = new Set(done.map((h) => h.status));
  const pending = STAGES.slice(STAGES.indexOf(status) + 1).filter((s) => !reached.has(s));
  const cancelled = status === "cancelled" || status === "payment_failed";

  return (
    <ol className="relative space-y-5" data-testid="order-timeline">
      <span className="absolute left-[11px] top-2 bottom-2 w-px bg-border" aria-hidden />
      {done.map((h, i) => (
        <li key={`${h.status}-${h.at}-${i}`} className="relative flex gap-4 pl-0" data-testid={`timeline-done-${h.status}`}>
          <span className={`relative z-10 mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full
            ${cancelled && i === done.length - 1 ? "bg-destructive text-white" : "bg-primary text-primary-foreground"}`}>
            <Check size={13} />
          </span>
          <div>
            <div className="text-sm font-medium">{LABELS[h.status] || h.status?.replace(/_/g, " ")}</div>
            <div className="text-xs text-muted-foreground">{when(h.at)}{h.note ? ` · ${h.note}` : ""}</div>
          </div>
        </li>
      ))}
      {!cancelled && pending.map((s) => (
        <li key={s} className="relative flex gap-4" data-testid={`timeline-pending-${s}`}>
          <span className="relative z-10 mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-muted text-muted-foreground">
            <Circle size={11} />
          </span>
          <div className="text-sm text-muted-foreground">{LABELS[s] || s}</div>
        </li>
      ))}
    </ol>
  );
};

export default OrderTimeline;
